export default __webpack_public_path__ + "static/media/icone-instagram.37b04841.svg";